import React from 'react';

import Spinner from '../Spinner';
import { Container } from './styles';

const Loading: React.FC = () => {
  return (
    <Container>
      <Spinner />
    </Container>
  );
};

export default Loading;
